import { render, staticRenderFns } from "./JoinCommunity.vue?vue&type=template&id=0d27acaa"
import script from "./JoinCommunity.vue?vue&type=script&lang=js"
export * from "./JoinCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports